module.exports = __webpack_public_path__ + "static/media/mood_4.fc38eefe.svg";